import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import styles from 'feature/login-flow/index.module.sass';
import Button from 'components/button';
import OnBoardingLayout from 'layout/onboarding';
import amplitude from 'service/amplitude';
import { PATH } from 'config';
import LoadingDialog from 'components/loading-dialog';
import repo from 'service/repository';
import { UPDATE_USER_INFO, useAppContext } from 'use-app';
import SelectCard from 'distributor/npc/module/select-card';
import BindCard from 'distributor/npc/module/bind-card';

const BindNpcCard = () => {
  const [npcCards, setNpcCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { state: appState, dispatch: appDispatch, showFailMessage } = useAppContext();

  useEffect(() => {
    amplitude.bindCard_pageview();
    repo.getNpcCards().then(value => setNpcCards(value));
  }, []);

  const bindNpc = ({ card, redeemState = true }, callback = () => {}) => {
    setLoading(true);

    repo
      .bindNpcPay({ cardType: card.type, enableRedeem: redeemState })
      .then(repo.fetchUserInfo)
      .then(value => {
        appDispatch({
          type: UPDATE_USER_INFO,
          payload: value,
        });
        callback();
      })
      .catch(error => {
        showFailMessage(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const BindCardForm = () => {
    const card = appState.me.currentCreditCard;

    const text = () => {
      if (!card.creditCardCategory) return '';

      if (card.creditCardCategory.name === '全國大利卡') {
        return `將使用您在${card.creditCardCategory.name}綁定且預設的一般信用卡進行扣款`;
      } else {
        return `將使用您在${card.creditCardCategory.name}綁定的聯名卡進行扣款`;
      }
    };

    const currentNpcCard = npcCards?.find(x => x.type === card.creditCardCategory.uid) || {};

    return (
      <div>
        <div className={styles.title}>已連結全國大利 PAY</div>
        <p>{text()}</p>
        <BindCard
          isOnBoarding={true}
          currentPoints={currentNpcCard.redeemBonusPoints || 0}
          onSwitchClick={() => {
            amplitude.bindNpcPay_switchRedeemUse_onClick({
              type: card.redeemBonusPoints.enableCreditPointRedeem ? 'off' : 'on',
            });
            bindNpc({
              card: { type: card.creditCardCategory.uid },
              redeemState: !card.redeemBonusPoints.enableCreditPointRedeem,
            });
          }}
        />
      </div>
    );
  };

  return (
    <OnBoardingLayout className={styles['bind-npc-card']}>
      <LoadingDialog isShow={loading} />
      <div className={styles.top}>
        <ul className={styles.progress}>
          <li className={styles.active}>1</li>
          <li className={styles.active}>2</li>
          <li className={styles.active}>3</li>
        </ul>
        {appState.me.currentCreditCard === null ? (
          <SelectCard
            cards={npcCards}
            onClick={card => {
              bindNpc({ card });
            }}
          />
        ) : (
          <BindCardForm />
        )}
      </div>
      {appState.me.currentCreditCard && (
        <div className={styles.bottom} style={{ marginTop: 20 }}>
          <Button
            theme="blue"
            block={true}
            onClick={() => {
              amplitude.bindCard_button_onClick({ paymentType: 'bind' });
              history.push(PATH.MAIN);
            }}
          >
            完成
          </Button>
        </div>
      )}
    </OnBoardingLayout>
  );
};

export default BindNpcCard;
